import { useZendeskUrl } from '~hooks/use-zendesk'

export function ZendeskRedirect() {
  const { zendeskUrl } = useZendeskUrl()
  window.location.replace(zendeskUrl)
  return null
}
